<script setup>
import { defineProps, onMounted, ref, defineEmits, watch } from "vue";
import Password from "@/components/form-fields/password/Index.vue";
import RetypePassword from "@/components/form-fields/retype-password/Index.vue";
import { useCustomer } from "@/hooks/shopify-hooks/useCustomer";
import { useCsrFormValidator } from "@/hooks/common/useCsrFormValidator";
import { isPhonePortrait } from "@/hooks/common/useUtils";
import { getEnvConfig } from "@/utils/common";
import { useInitGeetest, useGeetestLanguage } from "@/hooks/geetest/hooks";

const props =defineProps({
  stateKey: {
    type: String,
    default: "",
  },
  config: {
    type: Object,
    default: null,
  },
  customer: {
    type: Object,
    default: null,
  },
});

const newPasswordInput = ref(null);
const retypePasswordInput = ref(null);
const passwordValue = ref("");
const isLoading = ref(false);
const showPhoneNav = ref(false);

onMounted(() => {
  showPhoneNav.value = isPhonePortrait();
  initLoginGee();
});

// 初始化极验
const initLoginGee = () => {
  const { shopifyCaptchaId } = getEnvConfig();
  const language = document.documentElement?.getAttribute("lang") || "en"; // 获取html的lang值
  useInitGeetest({
    captchaId: shopifyCaptchaId,
    product: "bind",
    language: useGeetestLanguage(language),
    successCallBackFn: handleGeeSuccessCallBack,
  });
};

// 处理极验成功回调方法
const handleGeeSuccessCallBack = async (captchaObj, validateParams) => {
  useCsrFormValidator([newPasswordInput, retypePasswordInput])
    .then(async (res) => {
      const { newPassword } = res;
      const { updateCustomer } = useCustomer();
      if (isLoading.value) {
        return;
      }
      try {
        // 更新customer
        isLoading.value = true;
        const resdata = await updateCustomer({
          password: newPassword,
        },
          validateParams,props.config);
        isLoading.value = false;
        emit("loading", false);
        if (resdata) {
          emit("close");
        }
      } catch (e) {
        isLoading.value = false;
        console.error(e);
      }
    })
    .catch((e) => {
      console.error(e);
    });
};

const passwordChange = (e) => {
  passwordValue.value = e;
};

const emit = defineEmits(["close", "cancel"]);

const submitForm = async () => {
    useCsrFormValidator([newPasswordInput, retypePasswordInput])
    .then(async () => {
        window.captchaObj &&
    window.captchaObj.showCaptcha &&
    window.captchaObj.showCaptcha();
    })
    .catch((e) => {
      console.error(e);
    });

};

const clickCancel = () => {
  emit("cancel");
};

watch(
  () => isLoading.value,
  (value) => {
    emit("loading", value);
  }
);
</script>

<template>
  <div :class="{'form-v3-ecommerce': true, 'csr-account-form': true}">
    <div class="csr-account-form__nav-title" v-if="showPhoneNav" @click="() => clickCancel()">
      <div class="csr-account__back__icon"></div>
      {{ config.security.title }}
    </div>
    <form @submit.prevent="submitForm">
      <div class="csr-account-form__field">
        <Password
          ref="newPasswordInput"
          :data-conf="{
            label: config.security.passwordLabel,
            placeholder: config.security.passwordPlaceholder,
            required: true,
            name: 'newPassword',
            defErrorMsg: config.requiredFieldsPrompt,
            minlength: '8',
            restrictionHint: config.security?.passwordSecurityPrompt,
          }"
          @change="passwordChange"
        />
        <RetypePassword
          ref="retypePasswordInput"
          :data-conf="{
            label: config.security.rePasswordLabel,
            placeholder: config.security.rePasswordPlaceholder,
            required: true,
            name: 'retypePassword',
            defErrorMsg: config.requiredFieldsPrompt,
            formatHint: config.security.rePWSecurityPrompt,
            minlength: '8',
            restrictionHint: config.security?.passwordSecurityPrompt,
          }"
          :password="passwordValue"
        />
      </div>
      <div class="csr-account-form__btn-group">
        <button
          class="csr-account-form__btn md-button-v2 md-button md-button--primary"
          type="submit"
        >
          {{ config.confirmButton }}
        </button>
        <button
          class="csr-account-form__btn md-button-v2 md-button md-button--black"
          type="button"
          @click="() => clickCancel()"
        >
          {{ config.cancelButton }}
        </button>
      </div>
    </form>
  </div>
</template>